import { brandColors } from '@src/assets/colors/brandColors';
import SvgIconItalic from '@src/assets/images/common/icon/editor/SvgIconItalic';
import type { Editor } from '@tiptap/react';
import React from 'react';

interface ItalicButtonProps {
  editor: Editor;
  isActive: boolean;
  refreshActiveState: () => void;
}

export const ItalicButton: React.FC<ItalicButtonProps> = ({
  editor,
  isActive,
  refreshActiveState,
}) => {
  const activeHoverColor = brandColors['500'] || '#2B5CDD';
  const defaultIconColor = 'currentColor';

  return (
    <button
      onClick={() => {
        editor.view.dom.focus({ preventScroll: true });
        editor.chain().toggleItalic().run();
        refreshActiveState();
      }}
      className={`toolbar-button ${isActive ? 'active' : ''}`}
      title='斜体'
      type='button'
    >
      <SvgIconItalic color={isActive ? activeHoverColor : defaultIconColor} />
    </button>
  );
};
